import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";
import { CreateRoundInput } from "../../../__generated__/globalTypes";
import {
  CreateRoundMutation,
  CreateRoundMutationVariables,
} from "../../../__generated__/CreateRoundMutation";
import { CREATE_ROUND } from "../rounds.queries";
import { parseParams } from "../../../helpers/clean-object";
import { toast } from "react-toastify";

interface IProps {
  defaultValues: DeepPartial<CreateRoundInput>;
  onCompleted: () => any;
}

export const useCreateRound = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateRoundInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateRoundMutation,
    CreateRoundMutationVariables
  >(CREATE_ROUND);

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();

      console.log({ input: parseParams(input) });
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createRound?.ok) {
        onCompleted();
      } else {
        throw Error(data?.createRound?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
      toast.error("Une Erreur est survenue lors de la création de la tournée");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
